import { motion } from "framer-motion";

const STEPS = [
  { num: "01", testid: "step-item-01", title: "Crea la máquina", text: "Añade nombre, fabricante, modelo, número de serie, ubicación y fotografía." },
  { num: "02", testid: "step-item-02", title: "Añade su información", text: "Sube manuales, esquemas, documentación y fotografías." },
  { num: "03", testid: "step-item-03", title: "Generamos su QR", text: "Cada máquina recibe automáticamente un QR único que puedes imprimir y colocar sobre ella." },
  { num: "04", testid: "step-item-04", title: "Construye su historia", text: "Registra mantenimientos, averías, reparaciones, inspecciones y modificaciones." },
  { num: "05", testid: "step-item-05", title: "Accede cuando lo necesites", text: "Busca la máquina desde cualquier dispositivo o escanea su QR directamente en fábrica." },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="scroll-mt-20 bg-white border-b border-zinc-100" data-testid="como-funciona-steps">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-5">Cómo funciona</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
            De una máquina física a una máquina digital en minutos.
          </h2>
        </div>

        <div className="mt-16 lg:mt-24 max-w-4xl">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={s.testid}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.05 }}
              className="flex gap-8 sm:gap-14 py-10 border-b border-zinc-100 last:border-0 items-start"
            >
              <span className="font-heading text-5xl sm:text-7xl font-bold tracking-tight text-zinc-200 leading-none select-none">
                {s.num}
              </span>
              <div className="pt-1 sm:pt-3">
                <h3 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-zinc-900">
                  {s.title}
                </h3>
                <p className="text-base sm:text-lg text-zinc-600 leading-relaxed mt-2 max-w-xl">{s.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
